// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const T_TEST_STEP_SHAPES = [
  {
    stepType: PipelineStepType.T_TEST,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dataFormat: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'type',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'LONG'
              },
              labelColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              valueColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              labelsToUse: {
                kind: 'array',
                required: false,
                elementSpec: {
                  kind: 'string',
                  required: true
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'WIDE'
              },
              columns: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                },
                minItems: 1
              }
            }
          }
        ]
      },
      tTestType: {
        kind: 'enum',
        required: true,
        choices: [
          'INDEPENDENT',
          'PAIRED',
          'ONE_SAMPLE'
        ]
      },
      alternativeHypothesis: {
        kind: 'enum',
        required: true,
        choices: [
          'TWO_SIDED',
          'LESS_THAN',
          'GREATER_THAN'
        ]
      },
      significanceLevel: {
        kind: 'number',
        required: true
      },
      hypothesisMean: {
        kind: 'number',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
